import { ElementRef, Renderer2 } from '@angular/core';

export class XenaDSAccessor {

  constructor(protected element: ElementRef, protected renderer: Renderer2, private propertyName) {
    this.onChange = () => { };
  }

  onChange: (value: string) => void;
  onTouched: () => void;

  writeValue(value: any) {
    this.renderer.setProperty(this.element.nativeElement, this.propertyName, value);
  }

  _handleValueChange(event: CustomEvent) {
    let value = event.detail;
    event.stopPropagation();
    if (value != null && typeof (value) === 'object') {
      // Hack for XenaDS components setting value as a property in detail object.
      value = value.value;
    }
    this.onChange(value);
  }

  registerOnChange(fn: (value: string) => void) {
    this.onChange = value => {
      fn(value);
    };
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
}
